import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import ContractorAuthenticationModal from '../../../components/family-plaza/ContractorAuthenticationModal';
import PortraitPhotoRegistrationModal from '../../../components/family-plaza/PortraitPhotoRegistrationModal';
import { checkModalAuthenticationStatus, requireAuthentication } from '../../../utils/authUtils';
import { getDeceasedPersonDate, getDeceasedPersonProfileText, getUserIPAddress } from '../../../utils/profilePhotoUtils';

import FamilyPlazaTopSection from '../../../components/family-plaza/FamilyPlazaTopSection';
import FamilyPlazaSubHeading from '../../../components/family-plaza/FamilyPlazaSubHeading';
import CyberMemorialService from '../../../services/FamilyPlaza/CyberMemorialService';
import DeceasedPersonProfile from '../../../components/family-plaza/DeceasedPersonProfile';


const DonateRegistrationPC = () => {
  const navigate = useNavigate();
  const [selectedFlower, setSelectedFlower] = useState(0);
  const [message, setMessage] = useState('');
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [showPhotoModal, setShowPhotoModal] = useState(false);
  const [profilePhotoUrl, setProfilePhotoUrl] = useState('/donate/layer-1910.png');
  const [availableFlowers, setAvailableFlowers] = useState([]);
  const [isLoadingFlowers, setIsLoadingFlowers] = useState(false);
  const handleNavigation = (route) => { navigate(route); };


  // Load available flowers from API
  useEffect(() => {
    const loadAvailableFlowers = async () => {
      setIsLoadingFlowers(true);
      try {
            const response = await CyberMemorialService.getFlowers();
            
            if (response && response.layflowers) {
                 setAvailableFlowers(response.layflowers);
                 

            } else {
              setAvailableFlowers([]);
            }
      } catch (error) {
        console.error('Error loading available flowers:', error);
        setAvailableFlowers([]);
      } finally {
        setIsLoadingFlowers(false);
      }
    };

    loadAvailableFlowers();
  }, []);

  // Photo icon click handler
  const handlePhotoIconClick = () => {
    const isAuthenticated = checkModalAuthenticationStatus();
    
    if (isAuthenticated) {
      // If already authenticated, open photo modal directly
      setShowPhotoModal(true);
    } else {
      // If not authenticated, open auth modal first
      setShowAuthModal(true);
    }
  };

  // Authentication modal handlers
  const handleAuthConfirm = () => {
    setShowAuthModal(false);
    // Open photo registration modal after successful authentication
    setShowPhotoModal(true);
  };

  const handleAuthClose = () => {
    setShowAuthModal(false);
  };

  // Photo registration modal handlers
  const handlePhotoConfirm = () => {
    setShowPhotoModal(false);
  };

  const handlePhotoUpload = (photoUrl) => {
    console.log('Photo uploaded, updating profile photo:', photoUrl.substring(0, 50) + '...');
    // Update profile photo immediately when photo is uploaded
    setProfilePhotoUrl(photoUrl);
  };

  const handlePhotoClose = () => {
    setShowPhotoModal(false);
  };

 

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!requireAuthentication()) {
      return;
    }
    
    if (!message.trim()) {
      alert('전하실 말씀을 입력해주세요.');
      return;
    }
      
    const selectedPersonData = localStorage.getItem('selectedPersonData');
    let customerName = '이추모';
    let goinId = null;
    
    if (selectedPersonData) {
      try {
        const personData = JSON.parse(selectedPersonData);
        customerName = personData.customerName || '이추모';
        goinId = personData.goinId || null;
      } catch (error) {
        customerName = '이추모';
      }
    }

    try {
      // Get cherishId from localStorage
      const cherishId = localStorage.getItem('cherishId') || 0;
      
      // Get the selected flower's layflowerId
      let flowerId = 0;
      if (availableFlowers.length > 0 && availableFlowers[selectedFlower]) {
        flowerId = availableFlowers[selectedFlower].layflowerId;
      }

        const apiData = {
         flowerId: flowerId,
         cherishId: parseInt(cherishId),
         goinId: parseInt(goinId) || 0,
         layflowerTitle: message
        };

       const response = await CyberMemorialService.createCherishOfferMessage(apiData);
       
       if (response) {
        alert("헌화 등록에 성공했습니다.");
         navigate('/donate');
      } else {
        alert('헌화 등록에 실패했습니다. 다시 시도해주세요.');
      }
    } catch (error) {
      console.log('API error:', error);
      alert('헌화 등록에 실패했습니다. 다시 시도해주세요.');
    }
  };

  return (
       <div className="donate-registration-pc page-donate-registration-pc announcement-list-page donate-info-page-pc ">
   
   <FamilyPlazaTopSection />

   <main className="main-content">

   <FamilyPlazaSubHeading heading="사이버추모관" />

      {/* Main Content */}
      <div className="donate-registration-main-content">
        <div className="donate-registration-page-content">
          <div className="donate-registration-container">
        
            <DeceasedPersonProfile 
              handlePhotoIconClick={handlePhotoIconClick}
            />

            {/* Action Tabs Navigation */}
            <div className="donate-registration-action-tabs">
              <div className="donate-registration-action-tabs-container">
                <ul>
                  <li><Link to="/donate-registration" className="active">헌화하기</Link></li>
                  <li><Link to="/memorial-post-board-list">추모글</Link></li>
                  <li><Link to="/memorial-album-board-list">추모앨범</Link></li>
                </ul>
              </div>
            </div>

            {/* Content Area */}
            <form onSubmit={handleSubmit} className="donate-registration-content-area">
              {/* Flower Selection Section */}
              <div className="donate-registration-flower-section">
                <div className="donate-registration-section-label">
                  <label className="donate-registration-label">헌화 선택 *</label>
                </div>
                <div className="donate-registration-flower-options">
                  {isLoadingFlowers ? (
                    <div className="donate-registration-loading">
                      <p>헌화 목록을 불러오는 중...</p>
                    </div>
                  ) : availableFlowers.length > 0 && (
                    availableFlowers.map((flower, index) => (
                      <div key={flower.layflowerId} className="donate-registration-flower-option">
                        <input 
                          type="radio" 
                          name="flower-selection" 
                          id={`flower-${flower.layflowerId}`}
                          className="donate-registration-radio" 
                          checked={selectedFlower === index}
                          onChange={() => setSelectedFlower(index)}
                        />
                        <label htmlFor={`flower-${flower.layflowerId}`} className="donate-registration-flower-option-label">
                          <img src={flower.flowerImageUrl} alt={`Flower ${index + 1}`} />
                        </label>
                      </div>
                    ))
                  ) 
                  }
                </div>
              </div>

              {/* Message Section */}
              <div className="donate-registration-message-section">
                <div className="donate-registration-section-label">
                  <label className="donate-registration-label">전하실 말씀 *</label>
                </div>
                <div className="donate-registration-text-input-container">
                  <textarea 
                    className="donate-registration-text-input" 
                    placeholder="내용을 입력해주세요." 
                    rows="4"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                  ></textarea>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="donate-registration-form-actions">
                <button type="button" className="donate-registration-cancel-btn" onClick={() => handleNavigation('/donate')}>취소</button>
                <button type="submit" className="donate-registration-submit-btn">등록</button>
              </div>
            </form>

          </div>
        </div>
      </div>

      

      {/* Authentication Modal */}
      <ContractorAuthenticationModal
        isOpen={showAuthModal}
        onConfirm={handleAuthConfirm}
        onClose={handleAuthClose}
      />

      {/* Photo Registration Modal */}
      <PortraitPhotoRegistrationModal
        isOpen={showPhotoModal}
        onConfirm={handlePhotoConfirm}
        onClose={handlePhotoClose}
        onPhotoUpload={handlePhotoUpload}
      />

    </main>

    </div>
  );
};

export default DonateRegistrationPC; 